"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Grid_1 = __importDefault(require("@mui/material/Grid"));
var Box_1 = __importDefault(require("@mui/material/Box"));
require("../../scss/_two-row-details-card.scss");
/**
 * @component TwoRowDetailsGrid
 * @example
 * <TwoRowDetailsGrid
 *   column1Title="Down Payments"
 *   column1Value={000}
 *   column2Title="Transactions"
 *   column2Value={111}
 * />
 *
 * @param {string} title title of DetailsGrid
 * @param {string} column1Title title of 1st column
 * @param {string | number} column1Value value of 1st column
 * @param {string} column2Title title of 2nd column
 * @param {string | number} column2Value value of 2nd column
 * @param {string} column3Title title of 3rd column
 * @param {string | number} column3Value value of 3rd column
 *
 */
var TwoRowDetailsGrid = function (props) {
    var title = props.title, column1Title = props.column1Title, column1Value = props.column1Value, column2Title = props.column2Title, column2Value = props.column2Value, column3Title = props.column3Title, column3Value = props.column3Value;
    var headerText = function (content) { return (react_1.default.createElement(Box_1.default, { className: 'header-text-styles' }, content)); };
    var detailsText = function (content) { return (react_1.default.createElement(Box_1.default, { className: 'details-text-styles', fontWeight: "fontWeightBold" }, content)); };
    return (react_1.default.createElement("div", { className: 'px-4 py-4' },
        react_1.default.createElement(Grid_1.default, { container: true, spacing: 2 },
            title && (react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                react_1.default.createElement(Box_1.default, { className: 'title-styles' }, title))),
            react_1.default.createElement(Grid_1.default, { item: true, xs: 4 }, column1Title && headerText(column1Title)),
            react_1.default.createElement(Grid_1.default, { item: true, xs: 4 }, column2Title && headerText(column2Title)),
            react_1.default.createElement(Grid_1.default, { item: true, xs: 4 }, column3Title && headerText(column3Title)),
            react_1.default.createElement(Grid_1.default, { item: true, xs: 4 }, column1Value && detailsText(column1Value)),
            react_1.default.createElement(Grid_1.default, { item: true, xs: 4 }, column2Value && detailsText(column2Value)),
            react_1.default.createElement(Grid_1.default, { item: true, xs: 4 }, column3Value && detailsText(column3Value)))));
};
exports.default = TwoRowDetailsGrid;
